
import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import ErrorMessage from "../../common/ErrorMessage/ErrorMessage";
import {Link, useNavigate} from 'react-router-dom';
import { DialogContent, DialogTitle, Grid, Typography } from "@mui/material";

function ScatterPBI() {
  
    //This code helps to scroll to the top when the screen is open
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  const navigate = useNavigate();


  return (
    <Grid>
        <DialogTitle color="white">
            You have to become a signatory to contribute to the database. <br></br>
            <Typography color="gray">Interact with the charts below and learn about connections with UN SDGs</Typography>
            
        </DialogTitle>
    
    <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
            margin: '2rem',
            height: '100vh', // Set height to fill viewport
        }}
    >
        <iframe
            title="SCATTER PLOT FOR DEPLOYMENT"
            width="600"
            height="600"
            src="https://app.powerbi.com/view?r=eyJrIjoiMTUxZTEwNTctMDBlNi00MjhmLWJiNjctNTgzNGRjMWE4YjEyIiwidCI6ImM1MWJhMWYxLTYxZDEtNGExZi1hMTczLWJjZjJjOWE1NzBmZiIsImMiOjN9&pageName=ReportSection14da2c2f4e765c1e4ef6" 
            frameBorder="0"
            allowFullScreen="true"
            style={{ flex: 1, paddingRight: '5rem' }} // Adding paddingRight to the iframe style
        ></iframe>
    </Grid>
    </Grid>
);
}

export default ScatterPBI;

